import angular from 'angular';
import template from './desktop-actions.html';
class DesktopActionsController {
    onClickCallEnd(event) {
        event.stopImmediatePropagation();
        this.onCallEnd();
    }
}
const desktopActionsComponent = {
    template,
    bindings: {
        stream: '<',
        username: '<',
        disabled: '<',
        onToggleAudio: '&',
        hasCallEnd: '<',
        onCallEnd: '&',
        onTogglePin: '&',
        isPinned: '<',
        isInGroupCall: '<',
        isGalleryView: '<',
    },
    controller: DesktopActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.desktopActions', [])
    .component('desktopActions', desktopActionsComponent).name;
